var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "trial-end-clock",
        {
          attrs: {
            title: _vm.$t.__("common.labels.inactive_account"),
            subtitles: [
              _vm.$t.__("pages.errors.TrialEndCartExpired.thanks_contact_us")
            ]
          }
        },
        [
          _c("CompassButton", {
            attrs: {
              size: "large",
              label: _vm.$t.__("common.actions.contact_sales")
            },
            on: { click: _vm.contactSale }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "typographies-paragraph-medium-semibold help-message__container"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Revenir sur")) +
                  "\n            "
              ),
              _c("CompassLink", {
                attrs: {
                  label: _vm.$t.__("common.labels.sellsy_short_url"),
                  link: "https://go.sellsy.com"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }